import { useMutation } from 'react-query';
import { partnerService } from 'hq/services';

export const useArchivePartner = () => {
  const mutationFn = async (partnerId: string) => await partnerService.archivePartner(partnerId);

  return useMutation(mutationFn);
};
